<template>
  <div class="yunxiao teacher schedule full-page">
    <schedule-calendar
      :eventDays="eventDays"
      :defaultDate="defaultDate"
      @chooseDate="(v) => (this.choosedDate = v)"
      @monthChange="monthChangeHandler"
    />

    <div class="event-container">
      <van-loading type="spinner" v-if="courseLoading" size="calc(var(--w) * 16)">
        加载中...
      </van-loading>


      <template v-if="courseData.courseArrangeRecordVos.length > 0">
        <eventList :infos="courseData" />
      </template>

      <empty-page
        v-else-if="!courseLoading"
        :show="!courseLoading"
        :tips="'没有课程安排～'"
      />
    </div>
  </div>
</template>
<script>
import scheduleCalendar from "@x3/vue/comp/schedule-calendar.vue";
import eventList from "./eventList.vue";
import emptyPage from "@parent/components/empty-page.vue";
export default {
  name: "classSchedule",
  components: {
    scheduleCalendar,
    eventList,
    emptyPage,
  },
  data() {
    let strDate = this.$route.query.date,
      date;

    if (strDate) {
      date = new Date(strDate.replace(/-/g, "/"));
    } else {
      date = new Date();
    }

    return {
      pageTitle: "课表",
      // 默认日历显示日期
      defaultDate: date,
      // 选中天
      choosedDate: date,
      // 选中月
      currentMonth: app.tool.date.formatDatetime(date, "yyyy-MM"),
      eventDays: [],
      courseData: {
        date: '',
        courseQuantity: '',
        courseArrangeRecordVos: []
      },

      courseLoading: false,
    };
  },
  methods: {
    // 按月获取本月需上课情况
    async getMonthData() {
      let res = await this.$api.getCourseDate({
        monthDate: this.currentMonth,
      });
      if (res.code === 200) {
        this.eventDays = res.data;
      }
    },
    // 按天获取课表
    async getDayData() {
      this.courseLoading = true;
      try {
        if (this._cp) {
          try {
            this._cp.cancel();
          } catch (err) {
            console.log("取消上次计算了");
          }
        }
        this._cp = this.$api.getCourse({
          date: app.tool.date.formatDatetime(this.choosedDate, "yyyy-MM-dd"),
          page: {pageNum: 1, pageSize: 100},
        });
        let res = await this._cp;
        if (res.code === 200) {
          this.courseData = {
            date: res.data && res.data[0] && res.data[0].startTime, 
            // courseQuantity: res.page && res.page.totalCount,
            courseQuantity: (res.data || []).length,
            courseArrangeRecordVos: res.data || [],
          }
        }
        this.courseLoading = false;
        return res;
      } catch (err) {
        this.courseLoading = false;
        return Promise.reject(err);
      }
    },
    // 切换月
    monthChangeHandler(val) {
      // console.log(val);
      this.currentMonth = val;
    },
    // 切换日
    dayChangeHandler(val) {
      this.choosedDate = val;
    },
  },
  async created() {
    this.showLoading();

    let ajax = Promise.all([this.getMonthData(), this.getDayData()]);
    try {
      await ajax;
    } catch (err) {
      console.log(err);
    }
    this.$toast.clear();
  },
  watch: {
    currentMonth(nv, ov) {
      this.getMonthData();
    },
    choosedDate(nv, ov) {
      this.getDayData();
    },
  },
};
</script>

<style lang="scss" scoped>
.yunxiao.teacher.schedule {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .schedule-calendar-container {
    position: relative;
    z-index: 1;
  }
  .event-container {
    position: relative;
    padding-bottom: calc(var(--gap) * 32);
    flex: 1;
    overflow-y: auto;

    ::v-deep .van-loading {
      margin-top: calc(var(--gap) * 16);
      text-align: center;
    }
  }
}
</style>
